import type { AsyncState } from '../../platform/async/Async'

/** The categories list's state, as far as naming a category needs it. */
export type CategoryListStatus = AsyncState<unknown>['status']

/**
 * How a control names a SET category (ruling R7). `name` goes into the accessible
 * name; `shown` is the visible text. "Unknown category" is only true of a LOADED
 * list that lacks the id: while the list is loading or has failed we do not know,
 * so we do not claim to. Shared by `CategoryField` and the row pill.
 *
 * `found` is the category's name when the loaded list holds it.
 */
export function setCategoryLabel(status: CategoryListStatus, found: string | undefined): { name: string; shown: string } {
  if (status === 'loading') return { name: 'Loading', shown: 'Loading…' }
  if (status === 'error') return { name: 'Unavailable', shown: 'Category unavailable' }
  const name = found ?? 'Unknown category'
  return { name, shown: name }
}
